import { LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { useLegalClientBeneficiaryVersion } from '../hooks';
import { LegalClientBeneficiaryVersionView } from '../views';

export const LegalClientBeneficiaryVersionContainer = () => {
  const {
    initialValues,
    loading,
    error,
    isError,
    versions,
    breadcrumbsTitles,
    snapshot,
    fullName,
    snapshotLoading,
    versionId,
    onChangeVersion,
    onCloseVersionHistory,
  } = useLegalClientBeneficiaryVersion();

  const { t } = useTranslation();

  useScrollToTop([]);

  if (loading) {
    return <LoadingLayout />;
  }

  return (
    <LegalClientBeneficiaryVersionView
      breadcrumbsTitles={breadcrumbsTitles}
      countries={[]}
      error={
        isError
          ? error?.localizedDescription ??
            t('client.legal.legalClientBeneficiary.version.notVersionMessage')
          : undefined
      }
      fullName={fullName}
      initialValues={initialValues}
      kycData={snapshot?.value.kyc}
      snapshotLoading={snapshotLoading}
      versionId={versionId}
      versions={versions ?? []}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  );
};
